import { render, staticRenderFns } from "./ManagePageTitle.vue?vue&type=template&id=185c621a&scoped=true"
import script from "./ManagePageTitle.vue?vue&type=script&lang=ts"
export * from "./ManagePageTitle.vue?vue&type=script&lang=ts"
import style0 from "./ManagePageTitle.vue?vue&type=style&index=0&id=185c621a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c621a",
  null
  
)

export default component.exports